import React from 'react'
import {
  Button,
  Grid,
  Modal,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material'
import warningIcon from '../../../assets/images/warningicon.svg'
import { theme } from '../../../theme/DashboardTheme'

interface OptOutConfirmationModalProps {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
  type?: 'none' | 'monthly'
}

const OptOutConfirmationModal = (props: OptOutConfirmationModalProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const modalType = props.type || 'none'

  const getModalContent = () => {
    if (modalType === 'none') {
      return {
        title: 'Opt Out of All Emails?',
        body: (
          <>
            <Typography
              variant="body2"
              textAlign="center"
              color={'#615F6B'}
              sx={{
                fontSize: { xs: 13, md: 14, lg: 16 },
                lineHeight: { xs: 1.5, md: 1.5, lg: 1.6 },
                mb: 2,
              }}>
              If you opt out of all emails, you&apos;ll stop receiving all communications from mePrism.
            </Typography>
            <Typography
              variant="body2"
              mb={{ xs: 3, sm: 4, md: 4 }}
              textAlign="center"
              color={'#615F6B'}
              sx={{
                fontSize: { xs: 13, md: 14, lg: 16 },
                lineHeight: { xs: 1.5, md: 1.5, lg: 1.6 },
              }}>
              After opting out, you&apos;ll only be able to re-enable Monthly Updates—you won&apos;t be able to
              turn all emails back on.
              <br />
              <br />
              Are you sure you want to continue?
            </Typography>
          </>
        ),
        confirmText: 'Confirm & Opt Out',
      }
    } else {
      return {
        title: 'Switch to Monthly Updates?',
        body: (
          <Typography
            variant="body2"
            mb={{ xs: 3, sm: 4, md: 4 }}
            textAlign="center"
            color={'#615F6B'}
            sx={{
              fontSize: { xs: 13, md: 14, lg: 16 },
              lineHeight: { xs: 1.5, md: 1.5, lg: 1.6 },
            }}>
            You will not receive any emails other than monthly emails.
          </Typography>
        ),
        confirmText: 'Confirm',
      }
    }
  }

  const content = getModalContent()

  return (
    <Modal
      open={props.open}
      onClose={props.onCancel}
      sx={{
        backdropFilter: 'blur(5px)',
        background: 'rgba(0, 0, 0, 0.3)',
      }}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          outline: 'none',
          position: 'absolute',
          top: '50%',
          left: '50%',
          maxWidth: '600px',
          transform: 'translate(-50%, -50%)',
          width: !isMobile ? '40%' : '85%',
          background: '#fff',
          p: { xs: 4, sm: 5, md: 6 },
          borderRadius: '10px',
        }}>
        <Stack justifyContent="center" alignItems="center" flexDirection={'column'}>
          <img
            src={warningIcon}
            alt="Warning"
            style={{ width: '8vw', maxWidth: '100px', minWidth: '60px', height: 'auto' }}
          />
          <Typography
            variant="h2"
            mb={2}
            mt={{ xs: 3, sm: 4, md: 4 }}
            textAlign="center"
            sx={{
              fontSize: { xs: 18, md: 21, lg: 23 },
              fontWeight: 600,
              lineHeight: { xs: 1.2, md: 1.2, lg: 1.5 },
              color: '#3A155A',
            }}>
            {content.title}
          </Typography>
          {content.body}
        </Stack>
        <Grid
          item
          xs={12}
          sm={12}
          justifyContent="center"
          display="flex"
          gap={2}
          sx={{ flexDirection: { xs: 'column', sm: 'row' } }}>
          <Button
            variant={'outlined'}
            onClick={props.onCancel}
            sx={{
              width: { xs: '100%', sm: '48%' },
              borderRadius: '10px',
              fontSize: { xs: 12, md: 13, lg: 14 },
              padding: '10px 20px',
              border: '2px solid #9135E0',
              color: '#9135E0',
              backgroundColor: '#fff',
              '&:hover': {
                background: '#f5f5f5',
                border: '2px solid #9135E0',
                color: '#9135E0',
              },
            }}>
            Cancel
          </Button>
          <Button
            variant={'contained'}
            onClick={props.onConfirm}
            sx={{
              width: { xs: '100%', sm: '48%' },
              borderRadius: '10px',
              fontSize: { xs: 12, md: 13, lg: 14 },
              padding: '10px 20px',
              background: '#9135E0',
              color: '#fff',
              '&:hover': {
                background: '#7a2bbf',
              },
            }}>
            {content.confirmText}
          </Button>
        </Grid>
      </Grid>
    </Modal>
  )
}

export default OptOutConfirmationModal
